import { TenantType } from 'customers/tenants-common-view/lib/schema/Tenant.types';

export const isValidURL = (input: string) => {
  try {
    new URL(input);
    return true;
  } catch {
    return false;
  }
};

export const getUpdateOrAddTitleForOngoingIssueModal = (
  selectedTenant: TenantType,
) => `${selectedTenant?.tenantOngoingIssue ? 'Update' : 'Add'} Ongoing Issue`;
